import React, { useEffect } from 'react';
import { useTranslation } from '../i18n';

interface ToastProps {
  message: string;
  onDismiss: () => void;
  variant?: 'success' | 'error';
  durationMs?: number;
}

export const Toast: React.FC<ToastProps> = ({
  message,
  onDismiss,
  variant = 'success',
  durationMs = 5000,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(onDismiss, durationMs);
    return () => clearTimeout(timer);
  }, [message, durationMs, onDismiss]);

  return (
    <div className="toast-container">
      <div className={`toast toast--${variant}`} role="status" aria-live="polite">
        <span className="toast__message">{message}</span>
        <button
          type="button"
          className="toast__dismiss"
          onClick={onDismiss}
          aria-label={t('ui.toast_dismiss')}
        >
          &times;
        </button>
      </div>
    </div>
  );
};
